import React from 'react';
import { Header } from './../_common/header';
import { Personal } from './../../../../_common/personal';

export const SettingsProfil = () => {
    return (
        <Personal isSettings={true} />
    )
};